/**
 * Module-level access token store.
 *
 * The refresh token lives in an HttpOnly cookie managed by monosan —
 * it is never accessible from JS. Only the short-lived access token
 * and its expiry are kept here.
 */

export type Tokens = {
  accessToken: string
  expiresAt: number
}

let tokens: Tokens | null = null
const subscribers = new Set<() => void>()

const notify = (): void => {
  subscribers.forEach(fn => fn())
}

export const tokenStore = {
  get: (): Tokens | null => tokens,
  set: (next: Tokens | null): void => {
    tokens = next
    notify()
  },
  clear: (): void => {
    tokens = null
    notify()
  },
  subscribe: (fn: () => void): (() => void) => {
    subscribers.add(fn)
    return () => {
      subscribers.delete(fn)
    }
  },
}
